export enum EApplicationStatus {
  UNDER_REVIEW = 'UNDER_REVIEW',
  INITIAL_VETTING = 'INITIAL_VETTING',
  DOCUMENT_REVIEW = 'DOCUMENT_REVIEW',
  DOCUMENT_REQUESTED = 'DOCUMENT_REQUESTED',
  AWAITING_3RD_PARTY_REPORT = 'AWAITING_3RD_PARTY_REPORT',
  FINANCIAL_UNDERWRITING = 'FINANCIAL_UNDERWRITING',
  PROJECT_UNDERWRITING = 'PROJECT_UNDERWRITING',
  PARTNER_UNDERWRITING = 'PARTNER_UNDERWRITING',
  PHYSICAL_INSPECTION = 'PHYSICAL_INSPECTION',
  APPLICANT_UNDERWRITING = 'APPLICANT_UNDERWRITING',
  REFERENCE_CHECKING = 'REFERENCE_CHECKING',
  INTERNAL_REVIEW = 'INTERNAL_REVIEW',
  HOLD = 'HOLD',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  SUBMITTED = 'SUBMITTED',
}

export enum EApplicationFormType {
  CLIENT_APPLICATION = 'CLIENT_APPLICATION',
  PARTNER_PROPOSAL = 'PARTNER_PROPOSAL',
}

export const applicationStatusMapping: { [key: string]: string } = {
  APPROVE: 'APPROVED',
  DENY: 'DENIED',
  'UNDER REVIEW': 'UNDER_REVIEW',
};
